var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loader,
          expression: "loader"
        }
      ],
      staticClass: "wf-modal-loader my-basket-spiner"
    },
    [
      _c("div", { staticClass: "spinner-border", attrs: { role: "status" } }, [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$resourceString["myBasket.Loading.Label.Loading"]) +
              "\n        "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }